export const PAGE_SIZE = 100;
export const GAINERS_LOSERS_COUNT = 10;
export const HIGHLIGHTS_COINS_COUNT = 3;
